var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { LoadingButton } from '@one-thd/sui-atomic-components';
import ViewUpsBarcodeDrawer from './ViewUpsBarcodeDrawer';
import { useReturnLabelContext } from '../../../hooks/useContexts';
import { TagUPSBarcode } from '../../../utils/analytics';
import { getWindow } from '../../../utils/general';
var ViewUPSBarcodeButton = function (_a) {
    var _b, _c, _d, _e;
    var items = _a.items, _f = _a.variant, variant = _f === void 0 ? 'primary' : _f, isPTCOrder = _a.isPTCOrder;
    var _g = useReturnLabelContext(), loading = _g.loading, returnLabelResponse = _g.returnLabelResponse, fetchReturnLabel = _g.fetchReturnLabel, lastClicked = _g.lastClicked;
    var _h = useState(false), displayDrawer = _h[0], setDisplayDrawer = _h[1];
    var openDrawer = function () { return setDisplayDrawer(true); };
    var closeDrawer = function () { return setDisplayDrawer(false); };
    var handleClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var isOrderDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    event.stopPropagation();
                    isOrderDetails = variant === 'primary';
                    TagUPSBarcode(isOrderDetails);
                    if (returnLabelResponse) {
                        openDrawer();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetchReturnLabel('barcode')];
                case 1:
                    _a.sent();
                    openDrawer();
                    return [2 /*return*/];
            }
        });
    }); };
    var location = (_e = (_d = (_c = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location) === null || _c === void 0 ? void 0 : _c.pathname) === null || _d === void 0 ? void 0 : _d.split('/')) === null || _e === void 0 ? void 0 : _e[2];
    return (React.createElement("div", { className: "card-fix sui-order-1 ".concat(location === 'purchase-history'
            ? 'sui-w-full md:sui-ml-auto md:sui-max-w-[360px]'
            : '', "\n      ") },
        React.createElement(LoadingButton, { loading: loading && lastClicked === 'barcode', onClick: handleClick, variant: variant, "data-testid": "view-barcode-button" },
            React.createElement("span", null, "View UPS Barcode")),
        React.createElement(ViewUpsBarcodeDrawer, { displayDrawer: displayDrawer, closeDrawer: closeDrawer, items: items, returnLabelResponse: returnLabelResponse, isPTCOrder: isPTCOrder })));
};
export default ViewUPSBarcodeButton;
